import script from "./VslExpandHead.vue?vue&type=script&setup=true&lang=js"
export * from "./VslExpandHead.vue?vue&type=script&setup=true&lang=js"

import "./VslExpandHead.vue?vue&type=style&index=0&id=1546c2b6&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1546c2b6"]])

export default __exports__